/****************************/
/* Theme name  : Brave      */
/* Author name : Ashok      */
/****************************/

/*Back Function: Manipulating the browser history
*************************************************/
function goBack() {
    window.history.back();
}

/* **************/
/* csrf token   */
/* **************/

$(document).ready(function () {
    fetch(window.location.origin + '/csrf', {
        method: 'POST',
    })
        .then(async function (response) {
            if (response.status === 200) {
                const { token } = await response.json();
                if (document.querySelector('meta[name="csrf-token"]')) {
                    document.querySelector('meta[name="csrf-token"]').setAttribute('content', token);
                }

                if (document.querySelector('input[name="_token"]')) {
                    document.querySelector('input[name="_token"]').setAttribute('value', token);
                }

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                });
            } else {
                console.log('CSRF Error Occurred');
            }
        })
        .catch(function (err) {
            console.log(err)
            console.log('Error Occurred');
        });
});

/* ****************** */
/* Tooltips & Popover */
/* ****************** */
$(document).ready(function () {
    $(".b-tooltip").tooltip();

    $(".b-popover").popover();

});
/* ************** */
/* Magnific Popup */
/* ************** */

$(document).ready(function () {

    $('.wz-btn-add-to-cart, .wz-btn-edit-cart').removeClass('disabled');

    $('.lightbox').magnificPopup({type: 'image'});

    $('.letter_lightbox').click(function () {
        let element = $(this).closest('.la-cart-line').find('.letter_cart_contain');
        if (element.length === 0)  {
            element = $(this).prev('.checkup-table-product-image').find('.letter_cart_contain');
        }
        const classList = element[0].className.split(' ');
        const html = element.html();

        let classes = '';

        classList.forEach(function(value) {
            if ('letter_cart_contain' === value) return;

            classes += value + ' ';
        });

        $.magnificPopup.open({
            items: {
                src: '<div class="mfp-figure over ' + classes + '">' +
                    '<button class="mfp-close" type="button" title="Close (Esc)">×</button>' +
                    '<figure>' + html + '</figure>' +
                    '</div>',
                type: 'inline'
            }
        });
    });
});


/* *************** */
/* Custom Dropdown */
/* *************** */

$(document).ready(function () {
    var hidden = true;

    var isiPhone = /iphone/i.test(navigator.userAgent.toLowerCase());
    var isiPod = /ipod/i.test(navigator.userAgent.toLowerCase());
    var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
    var isBlackBerry = /blackberry/i.test(navigator.userAgent.toLowerCase());
    var isWebOS = /webos/i.test(navigator.userAgent.toLowerCase());
    var isWindowsPhone = /windows phone/i.test(navigator.userAgent.toLowerCase());
    var isMobile = false;

    if (isiPhone || isiPod || isAndroid || isBlackBerry || isWebOS || isWindowsPhone) {
        isMobile = true;
    }

    $("#hd_btn_shp.b-dropdown").click(function (e) {
        if (!isMobile) {
            e.preventDefault();
            if (hidden) {
                $(this).next('.b-dropdown-block').slideToggle(400, function () {
                    hidden = false;
                });
            }
        }
    });
    $(".b-dropdown:not(#hd_btn_shp)").click(function (e) {
        e.preventDefault();
        if (hidden) {
            $(this).next('.b-dropdown-block').slideToggle(400, function () {
                hidden = false;
            });
        }
    });
    $('html').click(function () {
        if (!hidden) {
            $('.b-dropdown-block, .b-dropdown-block-mobile').slideUp();
            hidden = true;
        }
    });
    $('.b-dropdown-block').click(function (event) {
        event.stopPropagation();
    });

    if (isMobile) {
        $('body').addClass('ismobile');
    }

    $(".b-dropdown-mobile").click(function (e) {
        if (isMobile) {
            e.preventDefault();
            if (hidden) {
                $(this).next('.b-dropdown-block-mobile').slideToggle(400, function () {
                    hidden = false;
                });
            }
        }
    });

});
/* ************ */
/* Owl Carousel */
/* ************ */

$(document).ready(function () {
    /* Owl carousel */
    /*$(".owl-carousel").owlCarousel({
        slideSpeed: 500,
        rewindSpeed: 1000,
        mouseDrag: true,
        stopOnHover: true
    }); */
    /* Own navigation */
    $(".owl-nav-prev").click(function () {
        $(this).parent().next(".owl-carousel").trigger('owl.prev');
    });
    $(".owl-nav-next").click(function () {
        $(this).parent().next(".owl-carousel").trigger('owl.next');
    });
});

/***************/
/* Flex slider */
/***************/

$(window).on('load', function () {
    var flex = $('.flexslider');
    flex.flexslider({
        slideshowSpeed: flex.data('slideshow-speed'),
        animationSpeed: flex.data('animation-speed'),
        controlNav: flex.data('control-nav'),
        directionNav: flex.data('direction-nav'),
        pauseOnHover: true
    });
});

/* ************* */
/* Scroll to top */
/* ************* */

$(document).ready(function () {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('.totop').fadeIn();
        } else {
            $('.totop').fadeOut();
        }
    });
    $(".totop a").click(function (e) {
        e.preventDefault();
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });
});


/* ********************/
/* jQuery.browser FIX */
/* ********************/

var matched, browser;

jQuery.uaMatch = function (ua) {
    ua = ua.toLowerCase();

    var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
        /(webkit)[ \/]([\w.]+)/.exec(ua) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
        /(msie) ([\w.]+)/.exec(ua) ||
        ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
        [];

    return {
        browser: match[1] || "",
        version: match[2] || "0"
    };
};

matched = jQuery.uaMatch(navigator.userAgent);
browser = {};

if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
}

// Chrome is Webkit, but Webkit is also Safari.
if (browser.chrome) {
    browser.webkit = true;
} else if (browser.webkit) {
    browser.safari = true;
}

jQuery.browser = browser;

// Extend jQuery
$.fn.triggerNative = function (eventName) {
    return this.each(function () {
        let el = $(this).get(0);
        triggerNativeEvent(el, eventName);
    });
};

function triggerNativeEvent(el, eventName) {
    if (el.fireEvent) { // < IE9
        (el.fireEvent('on' + eventName));
    } else {
        let evt = document.createEvent('Events');
        evt.initEvent(eventName, true, false);

        el.dispatchEvent(evt);
    }
}

/* **************/
/* Cart */
/* **************/
(function (xhr) {
    var nativeSend = xhr.prototype.send;
    window.ajaxEnabled = true;

    xhr.prototype.send = function () {
        if (window.ajaxEnabled) {
            nativeSend.apply(this, arguments);
        }
    };
}(window.XMLHttpRequest || window.ActiveXObject));

function addToCart(url) {
    $.ajax({
        url: url + '?_=' + new Date().getTime(),
        beforeSend: function () {
            $('body').addClass('loading');
        },
        success: function (response) {
            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'Web', 'add_to_cart', 'Add to Cart');
            }

            $('.cart-line-menu').html(response.html);
            $('#confirmCartModal').modal('show');
        },
        error: function(xhr, status) {
            if (status === 'abort') {
                return;
            }

            let response = JSON.parse(xhr.responseText);

            $('#add-cart-error').html(response.error || '-');
            $('#errorCartModal').modal('show');
        },
        complete: function () {
            $('body').removeClass('loading');
        },
    });
}

$(document).ready(function () {
    var cartTimeout = null;

    $("body .simplefancy").fancybox({
        trigger: 'click',
        html: true,
        container: 'body',
        placement: 'bottom',
        padding: 0,
        fitToView: true,
        helpers: {
            overlay: {
                showEarly: false
            }
        }
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('input[name="_token"]').val()
        }
    });

    $('.letter-form').on('submit', function (event) {
        if (typeof window.letterTool !== undefined) {
            letterTool.currentRequest.abort();
            window.ajaxEnabled = false;
        }
    });
    $('#confirmCartModal').on('hidden.bs.modal', function () {
        let stringField = $('#string');

        if (stringField.length) {
            stringField.triggerNative('keyup')
        }
    });
    $('a.wz-btn-edit-cart').on('click', function (event) {
        event.preventDefault();
        $('#confirmCartUpdateModal').modal('show');
        var url = $(this).attr('href');
        $.ajax({
            url: url,
            success: function (response) {
                $('.cart-line-menu').html(response.html);
                console.log(response);
            }
        })
    });
    $('form.form-add-card').on('submit', function (event) {
        event.preventDefault();
        var data = $(this).serialize();
        var url = $(this).attr('action');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                items: [{
                    price: Number($('.text-price:first').text().replace(',', '.')),
                    quantity: Number($('.quantity-field').val()),
                }]
            }
        });

        $.ajax({
            url: url,
            data: data,
            method: $(this).attr('method'),
            beforeSend: function() {
                $('body').addClass('loading');
            },
            success: function (response) {
                $('.cart-line-menu').html(response.html);
                $('#confirmCartModal').modal('show');
            },
            error: function (response) {
                console.log(response);
                $('#errorCartModal').modal('show');
            },
            complete: function() {
                // call sticker-traitement again to refresh
                $("#height").trigger('focusout')
                $('body').removeClass('loading');
            }
        });
    });
});


/* **************/
/* Popup Notice */
/* **************/

$(document).ready(function () {
    /*
    $('.open-notice-popup').magnificPopup({
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'mfp-fade'
    }); */

    $("#print-notice").click(function () {
        $('.print-element').printElement();
    });

    $(document).on('click', '.modal-popover', function(e) {
        e.preventDefault();
        $($(this).attr('href')).modal({ autoResize: true });
    });
});

/* *******************/
/*  SVG manipulation */
/* *******************/
$(document).ready(function () {
    setTimeout(function () {
        $('.miniature-svg').each(function () {
            const bbox = $(this).find('#texte_svg')[0].getBBox();

            let svg = $(this)[0];
            const lineElement = $(this).closest('.la-cart-line').length > 0 ? $(this).closest('.la-cart-line') : $(this).closest('tr');
            let largeurReelle = parseFloat(lineElement.find('.letter-width').text());
            let hauteurReelle = parseFloat(lineElement.find('.letter-height').text());
            let hauteur = bbox.height;
            let largeur = bbox.width;

            let realHeightElement = lineElement.find('.letter-real-height');
            let ratio = 1;

            if (realHeightElement.length) {
                let realHeight = parseFloat(realHeightElement.text());
                ratio = hauteurReelle / realHeight;
                hauteurReelle = realHeight;
            }

            let width = (largeurReelle * hauteur / hauteurReelle);
            hauteur *= ratio;

            // get data from created svg to know if the item is a stencil and needs margins
            let isStencil = $(this).closest('.letter_cart_contain ')[0].dataset.stencil.trim() == 'true' ? true : false;
            let hasMargin = $(this).closest('.letter_cart_contain ')[0].dataset.proportion == '1' ? true : false;
            let margin = 35;

            svg.setAttribute('viewBox', '0 0 ' + largeur + ' ' + hauteur);
            svg.setAttribute('height', hauteur);
            svg.setAttribute('preserveAspectRatio', 'none');
            svg.setAttribute('width', width);

            // if the item is a stencil and needs margin
            if (isStencil && hasMargin) {
                // add margin to the width
                svg.setAttribute('viewBox', '0 0 ' + (largeur + margin * 2) + ' ' + hauteur);
                svg.setAttribute('width', width + margin * 2);

                // translate the svg text inside its container so that it is centered
                $(this).find('#texte_svg')[0].setAttribute('style', 'transform: translate( '+ margin +'px , 0)');
            }
        });
    }, 500);
});
